// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3PFIy","file":"styles_file__2QbUC"};